import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [{
    q: '¿Qué formato tienen los materiales?',
    a: 'Todos los materiales son PDFs descargables de alta calidad. Los podés abrir en cualquier dispositivo (computadora, tablet, celular) y tenerlos siempre disponibles, incluso sin internet.'
  }, {
    q: '¿Necesito experiencia previa como entrenador?',
    a: 'No. El sistema está diseñado tanto para entrenadores con experiencia que quieren optimizar su tiempo, como para quienes recién arrancan y necesitan una guía clara y estructurada.'
  }, {
    q: '¿Sirve solo para fútbol?',
    a: 'El Megapack Fútbol está 100% enfocado en fútbol. Pero los 6 bonos (50 Sesiones, Sistema del Entrenador, Planes Semanales, etc.) son aplicables a cualquier deporte de equipo o individual.'
  }, {
    q: '¿Cómo accedo a los materiales después de comprar?',
    a: 'Inmediatamente después de completar el pago, recibirás un email con los links de descarga de todos los materiales. Acceso instantáneo, sin esperas.'
  }, {
    q: '¿Puedo pedir reembolso si no me sirve?',
    a: 'Sí. Tenés 30 días para probar todo el contenido. Si no te sirve, escribís un email y te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.'
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-55">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === index ? -1 : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-58">
                <span className="font-bold text-lg text-gray-900 pr-4" data-id="element-59">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>

              <AnimatePresence data-id="element-61">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-62">
                    <div className="px-6 pb-6 text-gray-700 leading-relaxed" data-id="element-63">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};